/** @jsx jsx */

import { jsx } from '@emotion/core';

import IntegrationListHeader from './IntegrationListHeader';
import Table from './Table';
import {
  IntegrationType,
  onDeleteCallback,
  onEditCallback,
  onViewCallback,
} from './types';

const Styles = {
  root: {
    fontSize: '15px',
  },
};

type Props = {
  /** An array of integrations. */
  integrations: Array<IntegrationType>;
  /** Callback when a version is to be deleted by chooseing 'Delete' on the dropdown. */
  onDelete: onDeleteCallback;
  /** Callback when a version is to be edited by chooseing 'Edit' on the dropdown. */
  onEdit: onEditCallback;
  /** Callback when a version is to be viewed by clicking on a row. */
  onView: onViewCallback;
};

/**
 * Renders a list of integrations built by VisualBuilder, WebBuilder or CLI.
 */
function IntegrationList(props: Props) {
  const { integrations, onDelete, onEdit, onView } = props;
  return integrations.length ? (
    <div css={Styles.root}>
      <IntegrationListHeader />
      <Table
        integrations={integrations}
        onDelete={onDelete}
        onEdit={onEdit}
        onView={onView}
      />
    </div>
  ) : null;
}

export default IntegrationList;
